/**
 * @desc 财务画像-基础信息-人员招聘
 */
import style from './degreetion.scss';
import React, { PureComponent } from 'react';
import BBDLineBar from '../../../common/echarts/BBDLineBar';
import GroupBox from '../../../common/groupBox/GroupBox';
import NoData from '../../../common/noData/NoData';
import { Col, Row, Spin } from 'antd';
import { isNotEmpty } from '../../../../utils/util';
import { commonRequest, commonLineOptin } from '../../common/commons';
import { recruitment } from '../../../../services/financialPicture/baseInfo';
import PersonMSPie from '../common/PersonMSPie';

export default class Recruitment extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            eduLoading: false,
            workLoading: false,
            personOption: {},
            eduOption: {},
            workAgeOption: {}
        };
    }

    componentDidMount() {
        this.recruitmentPort();
    }

    // 获取招聘人员数据
    recruitmentPort = () => {
        this.setState({
            loading: true
        });
        recruitment(commonRequest()).then(data => {
            data = data || {};
            this.setState({
                loading: false,
                personOption: this.formatPersonOption(data.time, data.timeList),
                eduOption: data.edu,
                workAgeOption: data.year
            });
        }).catch(() => {
            this.setState({
                loading: false
            });
        });
    };

    formatPersonOption = (lineData, timeList) => {
        let personNum = [], color = ['#534FCF'], grid = { top: 15, left: '3%', right: '2%' };
        for (var index in lineData) {
            personNum.push(lineData[index]);
        }
        return commonLineOptin({ lineData: personNum, category: timeList, color: color, 
            grid: grid, same: false, tip: true, title: true });
    };

    render() {
        const { loading, personOption, eduOption, workAgeOption } = this.state;
        return (
            <GroupBox id="recruitment" title="人才招聘">
                <div>
                    <Row>
                        <Col span={24}>
                            <p className="sub-title font-large">招聘人数时间分布</p>
                            <div className={style.recruitment}>
                                {loading ? <Spin title="数据加载中..." /> :
                                    isNotEmpty(personOption) ?
                                        <BBDLineBar option={personOption} /> :
                                        <NoData />
                                }
                            </div>
                        </Col>
                    </Row>
                    <div className={style.degreeDistribution}>
                        <Row>
                            <Col span={12}>
                                <div>
                                    <p className="sub-title font-bolder">学历分布</p>
                                    <PersonMSPie
                                        pieData={eduOption}
                                        loading={loading}
                                    />
                                </div>
                            </Col>
                            <Col span={12}>
                                <div>
                                    <p className="sub-title font-bolder">工作年限</p>
                                    <PersonMSPie
                                        pieData={workAgeOption}
                                        loading={loading}
                                        years={true}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </GroupBox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/baseInfo/personnelMessage/Recruitment.jsx